import { useState } from "react";
import {
    Container,
    Box,
    Paper,
    Typography,
    Tabs,
    Tab,
    Card,
    CardContent,
    Switch

} from "@mui/material";
import Logocolor from "../../Image/Logo.png";
import {
    Texto,
} from "../../Layouts/CustomStyles";
import { GiMoneyStack } from "react-icons/gi";
import { TabsIngresoINMOB } from "../../Components/INMOB/Ingresos";
import { useFinanzasTodosINMOB } from "../../Hook/Inmobiliaria/Finanzas";
import { formatCLP } from "../../Components/FuncionesGenerales/FormatoCLP";
import { TabsEgresosINMOB } from "../../Components/INMOB/Egresos";
import { FinanzasINMOB } from "../../Components/INMOB/Finanzas";

export const IndexInmob = () => {
    const { finanzas, loadingFinanzas, refetchFinanzas, finanzasMontoNeto, loadingFinanzasMontoNeto, refetchFinanzasMontoNeto } = useFinanzasTodosINMOB();
    const [tabIndex, setTabIndex] = useState(0);
    const [mostrarMontoNeto, setMostrarMontoNeto] = useState(false);
    const handleTabChange = (event, newValue) => setTabIndex(newValue);

    return (
        <Container maxWidth="xl" sx={{ py: 5 }}>
            <Paper
                elevation={4}
                sx={{
                    p: 4,
                    mb: 7,
                    borderRadius: "20px",
                    background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"

                }}
            >
                <Box sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mt: 2
                }}>
                    <Box display="flex" alignItems="center" gap={2}>
                        <img
                            src={Logocolor}
                            alt="Logo Clínica Activa"
                            style={{ width: 55, height: 55, objectFit: "contain" }}
                        />
                        <Typography variant="h5" sx={Texto}>
                            Inmobiliaria Fisiomeds
                        </Typography>
                    </Box>
                      <Box
    sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        
        
    }}
>
    <Typography
        sx={{
            fontFamily: "Poppins",
            fontWeight: 500,
            color: !mostrarMontoNeto ? "#2a8d74" : "#777",
        }}
    >
        Monto Total
    </Typography>

    <Switch
        checked={mostrarMontoNeto}
        onChange={(e) => setMostrarMontoNeto(e.target.checked)}
        color="success"
    />

    <Typography
        sx={{
            fontFamily: "Poppins",
            fontWeight: 500,
            color: mostrarMontoNeto ? "#2a8d74" : "#777",
        }}
    >
        Monto Neto
    </Typography>
</Box>
                </Box>
               
                  
                
                <Box mt={5} mb={5} gap={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
                    

                    <Card
                        sx={{
                            width: '50%',
                            backgroundColor: "#ffffff",
                            borderRadius: 3,
                            boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                            transition: "transform 0.2s, box-shadow 0.2s",
                        }}
                    >
                        <CardContent
                            gap={1}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: "80%",
                                    flexDirection: "column",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                }}
                                gap={1}
                                mb={1}
                            >
                                <Typography
                                    variant="h4"
                                    fontWeight={400}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                   {formatCLP(
        mostrarMontoNeto
            ? finanzasMontoNeto?.total_ingresos || 0
            : finanzas?.total_ingresos || 0
    )}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    Ingresos{" "}
                                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                        del  Mes
                                    </Box>
                                </Typography>

                            </Box>

                            <Box>
                                <GiMoneyStack size={60} color="#5cd09aff" />
                            </Box>
                        </CardContent>
                    </Card>
                    <Card
                        sx={{
                            width: '50%',
                            backgroundColor: "#ffffff",
                            borderRadius: 3,
                            boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                            transition: "transform 0.2s, box-shadow 0.2s",
                        }}
                    >
                        <CardContent
                            gap={1}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: "80%",
                                    flexDirection: "column",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                }}
                                gap={1}
                                mb={1}
                            >
                                <Typography
                                    variant="h4"
                                    fontWeight={400}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    {formatCLP(
        mostrarMontoNeto
            ? finanzasMontoNeto?.total_egresos || 0
            : finanzas?.total_egresos || 0
    )}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    Egresos{" "}
                                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                        del  Mes
                                    </Box>
                                </Typography>

                            </Box>

                            <Box>
                                <GiMoneyStack size={60} color="#5cd09aff" />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                <Box sx={{ mt: 5 }}>
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        variant="scrollable"   
                        scrollButtons={false}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#6fd385ff",
                                height: "3px",            
                                borderRadius: "2px",       
                            },
                        }}
                        sx={{
                            "& .MuiTab-root": {
                                minWidth: "auto",
                                px: 2,
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                borderRadius: "8px 8px 0 0", 
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#2a8d74", 
                                color: "#fff !important",   
                            },
                        }}>
                        <Tab label="Registro Ingresos" />
                        <Tab label="Registro Egresos" />
                        <Tab label="Registro financiero" />
                    </Tabs>

                    {tabIndex === 0 && (
                        <>
                            <TabsIngresoINMOB/>

                        </>
                    )}

                    {tabIndex === 1 && (
                        <>
                            <TabsEgresosINMOB/>
                        </>
                    )}
                     {tabIndex === 2 && (
                        <>
                           <FinanzasINMOB/>
                        </>
                    )}
                </Box>

            </Paper>

        </Container>
    )
}